import React from 'react'
import { Button } from '@sainsburys-tech/bolt'
import PropTypes from 'prop-types'
import Image from '../../../../helpers/Image/Image'
import * as Styled from './M0044.styles'

const M0044 = ({
  altText,
  backgroundImageUrl,
  badgeAltText,
  badgeUrl,
  bodyCopy,
  bundleSaving,
  ctaCopy,
  gridClasses,
  heading,
  linkTarget,
  linkUrl,
  linkTitle,
  price,
  saving,
  wasPrice
}) => {
  return (
    <Styled.Wrapper data-test='m0044-container' className={`${gridClasses || ''}`}>
      <Styled.Content>
        <Styled.ImageContainer data-test='m0044-image-container' href={linkUrl} target={linkTarget} title={linkTitle}>
          <Image alt={altText} src={backgroundImageUrl} smart />
        </Styled.ImageContainer>
        <Styled.TextContainer data-test='m0044-text-container'>
          {badgeUrl && (
            <Styled.BadgeContainer data-test='m0044-badge'>
              <Image alt={badgeAltText} src={badgeUrl} smart />
            </Styled.BadgeContainer>
          )}

          <Styled.Heading data-test='m0044-heading'>{heading}</Styled.Heading>
          <Styled.BodyCopy data-test='m0044-bodyCopy' dangerouslySetInnerHTML={{ __html: bodyCopy }} />
          {price && <Styled.Price data-test='m0044-price'>{price}</Styled.Price>}
          <Styled.SpansContainer data-test='m0044-savings-text-container'>
            {saving && <Styled.Saving data-test='m0044-savings'>{saving}</Styled.Saving>}
            {wasPrice && <Styled.WasPrice data-test='m0044-wasPrice'>{wasPrice}</Styled.WasPrice>}
            {bundleSaving && <Styled.BundleSaving data-test='m0044-bundleSaving'>{bundleSaving}</Styled.BundleSaving>}
          </Styled.SpansContainer>
        </Styled.TextContainer>
        <Styled.ButtonContainer data-test='m0044-ctaCard-container'>
          <Button kind='secondary' as='a' href={linkUrl} target={linkTarget} title={linkTitle}>
            {ctaCopy}
          </Button>
        </Styled.ButtonContainer>
      </Styled.Content>
    </Styled.Wrapper>
  )
}

M0044.propTypes = {
  altText: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  badgeAltText: PropTypes.string,
  badgeUrl: PropTypes.string,
  bodyCopy: PropTypes.string,
  bundleSaving: PropTypes.string,
  ctaCopy: PropTypes.oneOf(['Shop now', 'Shop bundle']),
  gridClasses: PropTypes.string,
  heading: PropTypes.string,
  linkTarget: PropTypes.oneOf(['', '_blank', '_self']),
  linkTitle: PropTypes.string,
  linkUrl: PropTypes.string,
  price: PropTypes.string,
  saving: PropTypes.string,
  wasPrice: PropTypes.string
}

M0044.defaultProps = {
  altText: '',
  backgroundImageUrl: '',
  badgeAltText: '',
  badgeUrl: '',
  bodyCopy: '',
  bundleSaving: '',
  ctaCopy: 'Shop now',
  gridClasses: '',
  heading: '',
  linkTarget: '',
  linkTitle: '',
  linkUrl: '',
  price: '',
  saving: '',
  wasPrice: ''
}

export default M0044
